import constants from '../../../../common/constants';
import registerConstants from '../constants/register-constants';
import CookiesWrapper from '../../../../common/cookies-wrapper';

class RegisterHelpers {
  static getUserType(location) {
    let userType = registerConstants.user_types.affiliate;
    let userRegisterObject = localStorage.getItem(constants.user_register_key_word);

    if (location && location.query && location.query.user_type) {
      userType = location.query.user_type;
    } else if (userRegisterObject) {
      userRegisterObject = JSON.parse(userRegisterObject);
      userType = userRegisterObject && userRegisterObject.user_type ? userRegisterObject.user_type : registerConstants.user_types.affiliate;
    }

    return userType;
  }

  static getCurrency() {
    const userRegisterObject = this.getUserRegisterObject();

    return userRegisterObject && userRegisterObject.currency ? userRegisterObject.currency : constants.currencies.usd.value;
  }

  static getUserRegisterObject() {
    const userRegisterObject = localStorage.getItem(constants.user_register_key_word);

    return userRegisterObject ? this.assignValuesToUserObject(userRegisterObject) : {};
  }

  static getTermsValue() {
    const userObject = this.getUserRegisterObject();
    return userObject.terms || false;
  }

  static assignValuesToUserObject(userRegisterObject) {
    userRegisterObject = JSON.parse(userRegisterObject);

    if (userRegisterObject.title === null || userRegisterObject.title === undefined) {
      userRegisterObject.title = 1;
    }

    return userRegisterObject;
  }

  static adjustUsername(username) {
    /* eslint-disable */
    return username
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^\w\-]+/g, '_')
      .replace(/\-\-+/g, '_')
      .replace(/^-+/, '_')
      .replace(/-+$/, '_');
    /* eslint-enable */
  }

  static determineUserType(values) {
    if (values[registerConstants.fields.managing_funds] === 'true') {
      if (values[registerConstants.fields.money_manager] === 'true') {
        return registerConstants.user_types.fund_manager;
      } else {
        return values[registerConstants.fields.tied_agent] === 'true' ? registerConstants.user_types.tied_agent : registerConstants.user_types.regional_office;
      }
    } else {
      return values[registerConstants.fields.coaching_clients] === 'true' ? registerConstants.user_types.educator : registerConstants.user_types.ibs;
    }
  }

  static setUtmParams(location) {
    const { query } = location;

    if (query) {
      const utmParams = CookiesWrapper.getCookie(registerConstants.utm_params_cookie) || {};

      for (var key in registerConstants.utm_params) {
        if (query[key] && utmParams[key] !== query[key]) {
          utmParams[key] = query[key];
        }
      }

      CookiesWrapper.setCookie(registerConstants.utm_params_cookie, utmParams);
    }
  }
}

export default RegisterHelpers;



// WEBPACK FOOTER //
// ./src/app/main/register/helpers/register-helpers.js